import { OperationMS } from '../../types';
import { CommandeAnalyse, TechNotes } from './types';
import { computeNoteGlobale } from './notationTechnique';
import {
  scoreTotal,
  resolveNoteFinanciere,
  buildFinancialPool,
  round2,
  WEIGHT_TECHNIQUE,
  WEIGHT_FINANCIERE,
} from './scoring';
import { isOffreValide } from './statutOffre';
import { getMontantAffiche } from './montants';
import { getCandidatureDate } from './historique';
import { resolveWinnerId } from './attribution';

// Construction des lignes de synthese (une par offre). Les notes des offres hors-lice
// (refus/expire) sont forcees a 0, comme le legacy. Les montants ponderes sont calcules
// ici (et plus en JSX) pour que l'affichage et le calcul partagent la meme source.
export interface SyntheseLine {
  id: string; // String(commande.id)
  commandeId: number | undefined;
  idStatus: number | undefined;
  nom: string;
  dateReponse: string | null;
  montant: number;
  noteTechnique: number;
  noteFinanciere: number;
  weightedTechnique: number;
  weightedFinanciere: number;
  noteTotal: number;
  isValide: boolean;
  isGagnant: boolean;
}

const commandesAnalyse = (operation: OperationMS): CommandeAnalyse[] =>
  (operation.commandes ?? []) as CommandeAnalyse[];

export const buildSyntheseLines = (
  operation: OperationMS,
  techNotes: TechNotes,
  manualSelection?: number | null,
): SyntheseLine[] => {
  const commandes = commandesAnalyse(operation);
  const pool = buildFinancialPool(commandes);
  const winnerId = resolveWinnerId(operation, techNotes, manualSelection);

  return commandes.map((commande) => {
    const valide = isOffreValide(commande.id_status);
    const noteTechnique = valide ? computeNoteGlobale(techNotes[String(commande.id)]) : 0;
    const noteFinanciere = valide ? resolveNoteFinanciere(commande, pool) : 0;
    const noteTotal = valide ? round2(scoreTotal(noteTechnique, noteFinanciere)) : 0;
    return {
      id: String(commande.id),
      commandeId: commande.id,
      idStatus: commande.id_status,
      nom: commande.contrat?.entite?.nom ?? '',
      dateReponse: getCandidatureDate(operation.historique, commande.id),
      montant: getMontantAffiche(commande),
      noteTechnique,
      noteFinanciere,
      weightedTechnique: round2(noteTechnique * WEIGHT_TECHNIQUE),
      weightedFinanciere: round2(noteFinanciere * WEIGHT_FINANCIERE),
      noteTotal,
      isValide: valide,
      isGagnant: commande.id !== undefined && commande.id === winnerId,
    };
  });
};
